import { apiClient } from './client';
// Workspace API functions (separated from company.ts)
export const workspaceApi = {
    // Create workspace for a client company
    create: (request) => apiClient.post(`/api/Workspaces/CreateWorkspace`, request),
    // Update workspace
    update: (workspace) => apiClient.put(`/api/Workspaces/UpdateWorkspace`, workspace),
    // Delete workspace (requires both workspace id and client company id per API contract)
    delete: (clientCompanyId, workspaceId) => apiClient.delete(`/api/Workspaces/${workspaceId}/${clientCompanyId}`),
    // Check whether a proposed Workspace slug is available within the given ClientCompany.
    checkSlug: (clientCompanyId, slug) => apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/CheckSlug?slug=${encodeURIComponent(slug)}`),
};
